import { render, staticRenderFns } from "./EstimateClipboardPreliminaryItems.vue?vue&type=template&id=48e24230&"
import script from "./EstimateClipboardPreliminaryItems.vue?vue&type=script&lang=js&"
export * from "./EstimateClipboardPreliminaryItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports